import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-play-fill text-xl"></i>
            </span>
            <span className="font-logo text-xl text-foreground-900">91短视频</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            91短视频致力于为用户提供丰富多样的短视频内容，涵盖搞笑、娱乐、生活、美食等热门类别。
            在这里，你可以轻松观看、收藏与分享喜欢的短视频，享受轻松愉快的碎片时光。
          </p>
          <p className="mt-4 text-xs text-foreground-400">
            本站为演示项目，所有视频与内容均为虚构示例，播放为模拟效果，不接入真实视频流。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">
            <span className="cursor-default">热门分类</span>
          </h4>
          <ul className="mt-4 space-y-2.5">
            {categories.map((category) => (
              <li key={category.slug}>
                <Link
                  to={`/category/${category.slug}`}
                  className="text-sm text-foreground-600 transition hover:text-primary-600"
                >
                  {category.name}短视频
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-900">
            <span className="cursor-default">快捷导航</span>
          </h4>
          <ul className="mt-4 space-y-2.5">
            <li>
              <Link to="/" className="text-sm text-foreground-600 transition hover:text-primary-600">
                首页
              </Link>
            </li>
            <li>
              <Link
                to="/favorites"
                className="text-sm text-foreground-600 transition hover:text-primary-600"
              >
                我的收藏
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="text-sm text-foreground-600 transition hover:text-primary-600"
              >
                关于我们
              </Link>
            </li>
            <li>
              <span className="text-sm text-foreground-600">反馈建议：demo@91short.example</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 91短视频 · 仅供演示使用</p>
          <p>热爱生活，热爱短视频</p>
        </div>
      </div>
    </footer>
  );
}